import { useEffect, useState } from "react";

import { searchTaxonomyItems } from "../../actions";

export type SearchTaxonomyOptions = {
  phrase: string;
  endpoint: string;
  immediate: boolean;
  params: Record<string, unknown>;
};

export const useFetchSearchTaxonomy = <ResponseType>(
  options: SearchTaxonomyOptions,
): [boolean, ResponseType[]] => {
  const [loading, setLoading] = useState(true);
  const [taxonomy, setTaxonomy] = useState<ResponseType[]>([]);

  useEffect(() => {
    searchTaxonomyItems({
      ...options,
    })
      .then((value) => {
        setTaxonomy(value as ResponseType[]);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [options]);

  return [loading, taxonomy];
};
